import { TASK_ENTITY } from '../../constants/entity'
import { USER_STATUS_ACTIVE } from '../../constants/user'
import { getApi, patchApi, postApi } from '../../utils/api'

export function createTask(data) {
  return postApi({ data, endpoint: `/api/pipeline/${TASK_ENTITY.single}/` })
}

export function getTaskFiles(id, params) {
  return getApi({
    endpoint: `/api/pipeline/${TASK_ENTITY.single}/${id}/files/`,
    params,
  })
}

export function getTaskType(params) {
  return getApi({
    endpoint: `/api/pipeline/${TASK_ENTITY.single}-type/`,
    params,
  })
}

export function updateTask(data, id) {
  return patchApi({
    data,
    endpoint: `/api/pipeline/${TASK_ENTITY.single}/${id}/`,
  })
}

export function getTask(id) {
  return getApi({ endpoint: `/api/pipeline/${TASK_ENTITY.single}/${id}/` })
}

export function updateTaskEmail(id, data) {
  return patchApi({
    data,
    endpoint: `api/pipeline/${TASK_ENTITY.single}/${id}/`,
  })
}

export function getTaskPriorities(params) {
  return getApi({
    endpoint: '/api/pipeline/activity-priority/',
    params,
  })
}

export function getTaskManagers({ search, ...restParams }) {
  return getApi({
    endpoint: '/api/manager-list-options/',
    params: {
      ...(search ? { fullname_or_email: search } : null),
      ...restParams,
      status: USER_STATUS_ACTIVE,
    },
  })
}

export function getMyTasks(params) {
  return getApi({
    endpoint: 'idwell-api/api/v3/widget/widgets/today-activities/',
    params,
  })
}
